import { FlatForm } from "../../../helpers/FormHelper";

export const getValitionApprovalForm = (formName, context) => {

    const result = new FlatForm(formName, context);
    result.initialise([
        "id",
        "status",
        "createdBy",
        "createdDate",
        "approvingOfficer",
        "comments",
        "newMeterNumber",
        "documents",
        "rejectOrApprove",
        "scenarios",

        "manufacturerAndModelChanged",
        "originalManufacturerAndModel",
        "newManufacturerAndModel",

        "otherManufacturerAndModelTextChanged",
        "originalOtherManufacturerAndModelText",
        "newOtherManufacturerAndModelText",

        "patternApprovalNumberChanged",
        "originalPatternApprovalNumber",
        "newPatternApprovalNumber",

        "meterSizeChanged",
        "originalMeterSize",
        "newMeterSize",

        "meterSerialNoChanged",
        "originalMeterSerialNo",
        "newMeterSerialNo",

        "lidSerialNumberChanged",
        "originalLidSerialNumber",
        "newLidSerialNumber",

        "lidInstallationDateChanged",
        "originalLidInstallationDate",
        "newLidInstallationDate"
    ])
    return result;
}